import React from 'react'
import {FolleteriaDigital} from "../components/marketing/FolleteriaDigital";

export const FolleteriaDigitalPage = () => {
    return (
        <FolleteriaDigital/>
    )
}
